export default __webpack_public_path__ + "static/media/7C414B78-F23A-41F9-A575-D09F0E75BA34.8e50a46d.jpg";